import React from 'react';
import { Accordion, Button } from 'react-bootstrap';
import './funcao.css';

function Apartamentos() {
  return (
    <div className="container mt-5 px-0">
      <p className="section-eyebrow text-center mb-2">Tour virtual</p>
      <h2 className="section-heading text-center d-inline-block w-100 mb-4">Tipos de quarto</h2>

      <Accordion defaultActiveKey="" flush className="accordion-hotel">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Quarto Casal</Accordion.Header>
          <Accordion.Body>
            <p><strong>Localização:</strong> parte lateral do hotel, com vista para garagem ou praça principal.</p>
            <p><strong>Comodidades:</strong> cama king, TV 43", frigobar, ar quente e frio, banheiro privativo.</p>

            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1753154019040!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eW9zQUNXQWM.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f356.64159188530675!4f-3.3270798522859195!5f0.7826214452107512" // Substituir pelo link correto da visualização 360
                width="100%"
                height="400"
                allowFullScreen
                loading="lazy"
                title="Quarto Suíte Master"
              ></iframe>
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>Quarto Duplo Solteiro</Accordion.Header>
          <Accordion.Body>
            <p><strong>Localização:</strong> parte lateral do hotel, com vista para garagem ou praça principal.</p>
            <p><strong>Comodidades:</strong> Disponibiliza duas camas de Solteiro, banheiro, TV e ar-condicionado quente e frio.</p>

            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1753154292446!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eXVBQUEtcko.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f356.6242082939338!4f-8.319265395369868!5f0.7820865974627469" // Substituir com o link correto do Street View 360
                width="100%"
                height="400"
                allowFullScreen
                loading="lazy"
                title="Quarto Executivo"
              ></iframe>
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>Duplo Casal</Accordion.Header>
          <Accordion.Body>
            <p><strong>Localização:</strong> parte lateral do hotel, com vista para garagem ou praça principal.</p>
            <p><strong>Comodidades:</strong> Disponibiliza duas camas de Casal, banheiro, TV e ar-condicionado quente e frio.</p>


            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1753154127685!6m8!1m7!1sCAoSHENJQUJJaEFEeWRFUnNnbXRBR2Y5eXFnQUFRbnQ.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f96.23333527507945!4f-15.036968059362422!5f0.7820865974627469" // Substituir com o link correto do Street View 360
                width="100%"
                height="400"
                allowFullScreen
                loading="lazy"
                title="Quarto Executivo"
              ></iframe>
            </div>
          </Accordion.Body>
        </Accordion.Item>




        <Accordion.Item eventKey="5">
          <Accordion.Header>Quarto Triplo</Accordion.Header>
          <Accordion.Body>
            <p><strong>Localização:</strong> parte lateral do hotel, com vista para garagem ou praça principal.</p>
            <p><strong>Comodidades:</strong> Disponibiliza quarto para até 3 pessoas Indivíduais ou Casal + Solteiro, banheiro, TV e ar-condicionado quente e frio.</p>


            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1753153868003!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eXdnQURjcGs.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f352.28700416093085!4f-19.0975077868938!5f0.7820865974627469" // Substituir com o link correto do Street View 360
                width="100%"
                height="400"
                allowFullScreen
                loading="lazy"
                title="Quarto Executivo"
              ></iframe>
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>Quarto Solteiro</Accordion.Header>
          <Accordion.Body>
            <p><strong>Localização:</strong> parte lateral do hotel, com vista para garagem ou praça principal.</p>
            <p><strong>Comodidades:</strong> Disponibiliza uma cama de Solteiro, banheiro, TV e ar-condicionado quente e frio.</p>

            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1753154427026!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eWxNQUFxdWk.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f283.0875788658984!4f-8.75901668221205!5f0.7820865974627469" // Substituir com o link correto do Street View 360
                width="100%"
                height="400"
                allowFullScreen
                loading="lazy"
                title="Quarto Executivo"
              ></iframe>
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="6">
          <Accordion.Header>Quarto Família Toda</Accordion.Header>
          <Accordion.Body>
            <p><strong>Localização:</strong> parte lateral do hotel, com vista para garagem ou praça principal.</p>
            <p><strong>Comodidades:</strong> Disponibiliza quarto para até 5 pessoas (Incluso cama de casal), banheiro, TV e ar-condicionado quente e frio.</p>

            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1753154190764!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eXlvQUJoSEY.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f301.7927188800964!4f-36.24334019259303!5f0.7820865974627469" // Substituir com o link correto do Street View 360
                width="100%"
                height="400"
                allowFullScreen
                loading="lazy"
                title="Quarto Executivo"
              ></iframe>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <div className="text-center mt-5">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://wa.me/5542933008907?text=Ol%C3%A1!%20Tudo%20bem%3F%0AGostaria%20de%20efetuar%20uma%20reserva%20no%20Hotel%20Marechal%20Express.%0APoderia%2C%20por%20favor%2C%20me%20informar%20sobre%20a%20disponibilidade%20e%20os%20procedimentos%20para%20confirmar%20a%20reserva%3F"
        >
          <Button className="btn-hotel-whatsapp w-100 py-3">Reservar apartamento no WhatsApp</Button>
        </a>
      </div>
    </div>
  );
}

export default Apartamentos;
